import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import DefensiveSecurityPage from './pages/services/DefensiveSecurityPage';
import OffensiveSecurityPage from './pages/services/OffensiveSecurityPage';
import DataCenterPage from './pages/services/DataCenterPage';
import NetworkEngineeringPage from './pages/services/NetworkEngineeringPage';
import CloudIntegrationPage from './pages/services/CloudIntegrationPage';
import ServerAdministrationPage from './pages/services/server-administration';
import IndustriesPage from './pages/IndustriesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import SOCServicePage from './pages/SOCServicePage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="services/:category/:service" element={<ServiceDetailPage />} />

        {/* Cybersecurity Services */}
        <Route path="services/cybersecurity/defensive-security" element={<DefensiveSecurityPage />} />
        <Route path="services/cybersecurity/offensive-security" element={<OffensiveSecurityPage />} />
        <Route path="services/cybersecurity/soc-as-a-service" element={<SOCServicePage />} />


        {/* Infrastructure Services */}
        <Route path="services/infrastructure/data-center-design" element={<DataCenterPage />} />
        <Route path="services/infrastructure/network-engineering" element={<NetworkEngineeringPage />} />
        <Route path="services/infrastructure/cloud-integration" element={<CloudIntegrationPage />} />
        <Route path="services/infrastructure/server-administration" element={<ServerAdministrationPage />} />


        {/* Other Pages */}
        <Route path="industries" element={<IndustriesPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
